import { render, staticRenderFns } from "./feeCheck.vue?vue&type=template&id=2fe6063f&scoped=true"
import script from "./feeCheck.vue?vue&type=script&lang=js"
export * from "./feeCheck.vue?vue&type=script&lang=js"
import style0 from "./feeCheck.vue?vue&type=style&index=0&id=2fe6063f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe6063f",
  null
  
)

export default component.exports